import { BookingClassName } from "@/app/[lang]/flights/components/FlightSelectorComponents/FlightPassengersContentComponentInterface";
import type { ResponseFlightGetDestinationsPresenter } from "@/libs/client/dexter/flight/flightDestinationsInterfaces/flightDestinationsInterfaces";
import getDateBetween from "@/utils/common/dateHelper/getDayBetween";
import dayjs from "@/utils/dayjs";
import {
  FlightTravel,
  FlightType,
} from "@/utils/enums/FlightTabResultListEnum";
import { LocalStorageItemEnum } from "@/utils/enums/LocalStorageItemEnum";

import { jsonParse } from "../jsonHelper/jsonHelper";
import { getLocalStorageItem } from "../localStorageItemHelper/localStorageItemUtills";

export const itemCategory3TierRoom = (pricePerNight?: number): string => {
  if (pricePerNight) {
    if (pricePerNight < 3000) {
      return "L";
    }
    if (pricePerNight >= 3000 && pricePerNight < 10000) {
      return "M";
    }
    return "H";
  }
  return "";
};

export function formatToFixedTwoDigitString(x: string | number) {
  const toString = x.toString();
  return Number.parseFloat(toString).toFixed(2) || "0.00";
}

export function formatToFixedTwoDigitNumber(x: string) {
  return Number(Number.parseFloat(x).toFixed(2)) || 0;
}

export function calDiffDuration(departure: string, arrival: string) {
  const departureDate = dayjs(departure);
  const arrivalDate = dayjs(arrival);
  return getDateBetween(departureDate, arrivalDate);
}

export function getFlightType(currentTab: number) {
  if (currentTab === 0) {
    return "round_trip";
  }
  if (currentTab === 1) {
    return "oneway_trip";
  }
  return "multi_trip";
}
export function getFlightTypeGa(currentTab: number) {
  if (currentTab === 0) {
    return FlightTravel.ROUNDTRIP;
  }
  if (currentTab === 1) {
    return FlightTravel.SINGLETRIP;
  }
  return FlightTravel.MULTITRIP;
}

export function getFlightTypeByParam(currentTab: string) {
  if (currentTab === FlightTravel.ROUNDTRIP) {
    return FlightTravel.ROUNDTRIP;
  }
  if (currentTab === "oneway") {
    return FlightTravel.SINGLETRIP;
  }
  return FlightTravel.MULTITRIP;
}

export function getBookingClass(bookingClass: string) {
  switch (bookingClass) {
    case "Y":
      return BookingClassName.Y;
    case "W":
      return BookingClassName.W;
    case "J":
      return BookingClassName.J;
    case "F":
      return BookingClassName.F;
    default:
      return BookingClassName.Y;
  }
}
export function getFlightDestinationHistories() {
  const flightSearchDestinationHistoriesDeparture = getLocalStorageItem(
    LocalStorageItemEnum.FLIGHT_SEARCH_HISTORIES,
  );
  const flightSearchDestinationHistoriesReturn = getLocalStorageItem(
    LocalStorageItemEnum.FLIGHT_SEARCH_HISTORIES,
  );

  const toJsonDeparture: ResponseFlightGetDestinationsPresenter[] =
    (flightSearchDestinationHistoriesDeparture &&
      jsonParse(flightSearchDestinationHistoriesDeparture)) ||
    [];
  const toJsonReturn: ResponseFlightGetDestinationsPresenter[] =
    (flightSearchDestinationHistoriesReturn &&
      jsonParse(flightSearchDestinationHistoriesReturn)) ||
    [];
  let flightType = "";
  if (
    toJsonDeparture[1]?.country_slug === toJsonReturn[0]?.country_slug &&
    toJsonDeparture[1]?.country_slug !== "" &&
    toJsonReturn[0]?.country_slug !== ""
  ) {
    flightType = FlightType.DOMESTIC;
  } else if (
    toJsonDeparture[1]?.country_slug !== toJsonReturn[0]?.country_slug &&
    toJsonDeparture[1]?.country_slug !== "" &&
    toJsonReturn[0]?.country_slug !== ""
  ) {
    flightType = FlightType.INTERNATIONAL;
  }
  return flightType;
}

export const getItemListNameText = (
  baseId: string,
  parentId: string,
  itemId: string,
  setHeadItemListName: (value: string) => void,
  setSubItemListName: (value: string) => void,
  buttonQuery?: string,
) => {
  const baseElement = document.getElementById(baseId);
  // console.log("baseElement", baseElement);

  if (!baseElement) return;

  const parent = baseElement.closest(`#${parentId}`);
  // console.log("parent", parent);

  if (!parent) return;

  const target = parent.querySelector(`#${itemId}`);
  // console.log("target", target);

  setHeadItemListName(target?.textContent?.trim() || "");

  let selectedButton = parent.querySelector(`button[tabindex="0"]`);
  // console.log("selectedButton", selectedButton);

  if (!selectedButton) return;

  let tabContent = selectedButton.querySelector('[data-slot="tabContent"]');
  if (tabContent) {
    setSubItemListName(tabContent?.textContent?.trim() || "");
  } else {
    selectedButton = parent.querySelector(
      `button[tabindex="0"]${buttonQuery || ""}`,
    );
    if (!selectedButton) return;
    tabContent = selectedButton.querySelector('[data-slot="tabContent"]');

    setSubItemListName(
      tabContent?.textContent?.trim() ||
        selectedButton?.querySelector("p")?.textContent ||
        "",
    );
  }
};
